<div class="oauth-main">
    <h3>{{"OAUTH_MESSAGE" | translate}}</h3>
</div>
